import { SteemActionType } from '@popup/steem/actions/action-type.enum';
import Config from 'src/config';
const SteemEngineConfigReducer = (state = {
    rpc: Config.steemEngine.rpc,
    mainnet: Config.steemEngine.mainnet,
    accountHistoryApi: Config.steemEngine.accountHistoryApi,
}, { type, payload }) => {
    switch (type) {
        case SteemActionType.HE_SET_ACTIVE_ACCOUNT_HISTORY_API:
            return Object.assign(Object.assign({}, state), { accountHistoryApi: payload === null || payload === void 0 ? void 0 : payload.accountHistoryApi });
        case SteemActionType.HE_SET_ACTIVE_RPC:
            return Object.assign(Object.assign({}, state), { rpc: payload === null || payload === void 0 ? void 0 : payload.rpc });
        case SteemActionType.HE_LOAD_CONFIG:
            return Object.assign(Object.assign({}, state), { rpc: payload === null || payload === void 0 ? void 0 : payload.rpc, accountHistoryApi: payload === null || payload === void 0 ? void 0 : payload.accountHistoryApi });
        default:
            return state;
    }
};
export default SteemEngineConfigReducer;
